"use strict";
// Generated from src/KojiParser.g4 by ANTLR 4.7.3-SNAPSHOT
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateContext = exports.PlaceContext = exports.PersonContext = exports.BugHoleContext = exports.IllegibleContext = exports.AnnotationContext = exports.TatetenContext = exports.OkuriganaContext = exports.KaeritenContext = exports.FuriganaContext = exports.FuriganaTargetContext = exports.SyntaxSugarContext = exports.PostPositionedAttrsContext = exports.TextSegmentContext = exports.BlockContent5Context = exports.Block5Context = exports.BlockContent4Context = exports.Block4Context = exports.BlockContent3Context = exports.Block3Context = exports.BlockContent2Context = exports.Block2Context = exports.BlockContent1Context = exports.Block1Context = exports.BlockContext = exports.InlineContentContext = exports.InlineContentSeqContext = exports.InlineContext = exports.ListContext = exports.KojiContext = exports.KojiParser = void 0;
const ATN_1 = require("antlr4ts/atn/ATN");
const ATNDeserializer_1 = require("antlr4ts/atn/ATNDeserializer");
const NoViableAltException_1 = require("antlr4ts/NoViableAltException");
const Parser_1 = require("antlr4ts/Parser");
const ParserRuleContext_1 = require("antlr4ts/ParserRuleContext");
const ParserATNSimulator_1 = require("antlr4ts/atn/ParserATNSimulator");
const RecognitionException_1 = require("antlr4ts/RecognitionException");
const Token_1 = require("antlr4ts/Token");
const VocabularyImpl_1 = require("antlr4ts/VocabularyImpl");
const Utils = require("antlr4ts/misc/Utils");
let KojiParser = /** @class */ (() => {
    class KojiParser extends Parser_1.Parser {
        constructor(input) {
            super(input);
            this._interp = new ParserATNSimulator_1.ParserATNSimulator(KojiParser._ATN, this);
        }
        // @Override
        // @NotNull
        get vocabulary() {
            return KojiParser.VOCABULARY;
        }
        // tslint:enable:no-trailing-whitespace
        // @Override
        get grammarFileName() { return "KojiParser.g4"; }
        // @Override
        get ruleNames() { return KojiParser.ruleNames; }
        // @Override
        get serializedATN() { return KojiParser._serializedATN; }
        // @RuleVersion(0)
        koji() {
            let _localctx = new KojiContext(this._ctx, this.state);
            this.enterRule(_localctx, 0, KojiParser.RULE_koji);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 63;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while ((((_la) & ~0x1F) === 0 && ((1 << _la) & ((1 << KojiParser.OpenBlock1) | (1 << KojiParser.OpenBlock2) | (1 << KojiParser.OpenBlock3) | (1 << KojiParser.OpenBlock4) | (1 << KojiParser.OpenBlock5) | (1 << KojiParser.OpenInline) | (1 << KojiParser.FuriganaPre) | (1 << KojiParser.AnnotationOpen) | (1 << KojiParser.PersonOpen) | (1 << KojiParser.PlaceOpen) | (1 << KojiParser.DateOpen) | (1 << KojiParser.KaeritenMark) | (1 << KojiParser.TatetenChar) | (1 << KojiParser.OkuriganaMark) | (1 << KojiParser.IllegibleMark) | (1 << KojiParser.BugHoleMark) | (1 << KojiParser.NonJp) | (1 << KojiParser.Kanji) | (1 << KojiParser.Kana))) !== 0) || _la === KojiParser.Lb) {
                        {
                            {
                                this.state = 60;
                                this.list();
                            }
                        }
                        this.state = 65;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 66;
                    this.match(KojiParser.EOF);
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        list() {
            let _localctx = new ListContext(this._ctx, this.state);
            this.enterRule(_localctx, 2, KojiParser.RULE_list);
            try {
                this.state = 73;
                this._errHandler.sync(this);
                switch (this.interpreter.adaptivePredict(this._input, 1, this._ctx)) {
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        {
                            this.state = 68;
                            this.block();
                        }
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        {
                            this.state = 69;
                            this.inline();
                        }
                        break;
                    case 3:
                        this.enterOuterAlt(_localctx, 3);
                        {
                            this.state = 70;
                            this.syntaxSugar();
                        }
                        break;
                    case 4:
                        this.enterOuterAlt(_localctx, 4);
                        {
                            this.state = 71;
                            this.textSegment();
                        }
                        break;
                    case 5:
                        this.enterOuterAlt(_localctx, 5);
                        {
                            this.state = 72;
                            this.match(KojiParser.Lb);
                        }
                        break;
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        inline() {
            let _localctx = new InlineContext(this._ctx, this.state);
            this.enterRule(_localctx, 4, KojiParser.RULE_inline);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 75;
                    this.match(KojiParser.OpenInline);
                    this.state = 76;
                    this.match(KojiParser.ElemName);
                    this.state = 78;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.ID) {
                        {
                            this.state = 77;
                            this.match(KojiParser.ID);
                        }
                    }
                    this.state = 83;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while (_la === KojiParser.Class) {
                        {
                            {
                                this.state = 80;
                                this.match(KojiParser.Class);
                            }
                        }
                        this.state = 85;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 86;
                    this.match(KojiParser.Colon);
                    this.state = 87;
                    _localctx._inlineContentSeq = this.inlineContentSeq();
                    _localctx._content.push(_localctx._inlineContentSeq);
                    this.state = 92;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while (_la === KojiParser.Bar) {
                        {
                            {
                                this.state = 88;
                                this.match(KojiParser.Bar);
                                this.state = 89;
                                _localctx._inlineContentSeq = this.inlineContentSeq();
                                _localctx._content.push(_localctx._inlineContentSeq);
                            }
                        }
                        this.state = 94;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 95;
                    this.match(KojiParser.CloseInline);
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        inlineContentSeq() {
            let _localctx = new InlineContentSeqContext(this._ctx, this.state);
            this.enterRule(_localctx, 6, KojiParser.RULE_inlineContentSeq);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 100;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while (((((_la - 11)) & ~0x1F) === 0 && ((1 << (_la - 11)) & ((1 << (KojiParser.OpenInline - 11)) | (1 << (KojiParser.FuriganaPre - 11)) | (1 << (KojiParser.AnnotationOpen - 11)) | (1 << (KojiParser.PersonOpen - 11)) | (1 << (KojiParser.PlaceOpen - 11)) | (1 << (KojiParser.DateOpen - 11)) | (1 << (KojiParser.KaeritenMark - 11)) | (1 << (KojiParser.TatetenChar - 11)) | (1 << (KojiParser.OkuriganaMark - 11)) | (1 << (KojiParser.IllegibleMark - 11)) | (1 << (KojiParser.BugHoleMark - 11)) | (1 << (KojiParser.NonJp - 11)) | (1 << (KojiParser.Kanji - 11)) | (1 << (KojiParser.Kana - 11)) | (1 << (KojiParser.Lb - 11)))) !== 0)) {
                        {
                            {
                                this.state = 97;
                                this.inlineContent();
                            }
                        }
                        this.state = 102;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        inlineContent() {
            let _localctx = new InlineContentContext(this._ctx, this.state);
            this.enterRule(_localctx, 8, KojiParser.RULE_inlineContent);
            try {
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 107;
                    this._errHandler.sync(this);
                    switch (this.interpreter.adaptivePredict(this._input, 6, this._ctx)) {
                        case 1:
                            {
                                this.state = 103;
                                this.syntaxSugar();
                            }
                            break;
                        case 2:
                            {
                                this.state = 104;
                                this.textSegment();
                            }
                            break;
                        case 3:
                            {
                                this.state = 105;
                                this.inline();
                            }
                            break;
                        case 4:
                            {
                                this.state = 106;
                                this.match(KojiParser.Lb);
                            }
                            break;
                    }
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        block() {
            let _localctx = new BlockContext(this._ctx, this.state);
            this.enterRule(_localctx, 10, KojiParser.RULE_block);
            try {
                this.state = 114;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case KojiParser.OpenBlock1:
                        this.enterOuterAlt(_localctx, 1);
                        {
                            this.state = 109;
                            this.block1();
                        }
                        break;
                    case KojiParser.OpenBlock2:
                        this.enterOuterAlt(_localctx, 2);
                        {
                            this.state = 110;
                            this.block2();
                        }
                        break;
                    case KojiParser.OpenBlock3:
                        this.enterOuterAlt(_localctx, 3);
                        {
                            this.state = 111;
                            this.block3();
                        }
                        break;
                    case KojiParser.OpenBlock4:
                        this.enterOuterAlt(_localctx, 4);
                        {
                            this.state = 112;
                            this.block4();
                        }
                        break;
                    case KojiParser.OpenBlock5:
                        this.enterOuterAlt(_localctx, 5);
                        {
                            this.state = 113;
                            this.block5();
                        }
                        break;
                    default:
                        throw new NoViableAltException_1.NoViableAltException(this);
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        block1() {
            let _localctx = new Block1Context(this._ctx, this.state);
            this.enterRule(_localctx, 12, KojiParser.RULE_block1);
            let _la;
            try {
                let _alt;
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 116;
                    this.match(KojiParser.OpenBlock1);
                    this.state = 117;
                    this.match(KojiParser.ElemName);
                    this.state = 119;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.ID) {
                        {
                            this.state = 118;
                            this.match(KojiParser.ID);
                        }
                    }
                    this.state = 124;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while (_la === KojiParser.Class) {
                        {
                            {
                                this.state = 121;
                                this.match(KojiParser.Class);
                            }
                        }
                        this.state = 126;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 127;
                    this.match(KojiParser.HeaderLb);
                    this.state = 131;
                    this._errHandler.sync(this);
                    _alt = this.interpreter.adaptivePredict(this._input, 10, this._ctx);
                    while (_alt !== 2 && _alt !== ATN_1.ATN.INVALID_ALT_NUMBER) {
                        if (_alt === 1) {
                            {
                                {
                                    this.state = 128;
                                    _localctx._blockContent1 = this.blockContent1();
                                    _localctx._content.push(_localctx._blockContent1);
                                }
                            }
                        }
                        this.state = 133;
                        this._errHandler.sync(this);
                        _alt = this.interpreter.adaptivePredict(this._input, 10, this._ctx);
                    }
                    this.state = 135;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.CloseBlock1) {
                        {
                            this.state = 134;
                            this.match(KojiParser.CloseBlock1);
                        }
                    }
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        blockContent1() {
            let _localctx = new BlockContent1Context(this._ctx, this.state);
            this.enterRule(_localctx, 14, KojiParser.RULE_blockContent1);
            try {
                this.state = 145;
                this._errHandler.sync(this);
                switch (this.interpreter.adaptivePredict(this._input, 12, this._ctx)) {
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        {
                            this.state = 137;
                            this.syntaxSugar();
                        }
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        {
                            this.state = 138;
                            this.textSegment();
                        }
                        break;
                    case 3:
                        this.enterOuterAlt(_localctx, 3);
                        {
                            this.state = 139;
                            this.inline();
                        }
                        break;
                    case 4:
                        this.enterOuterAlt(_localctx, 4);
                        {
                            this.state = 140;
                            this.match(KojiParser.Lb);
                        }
                        break;
                    case 5:
                        this.enterOuterAlt(_localctx, 5);
                        {
                            this.state = 141;
                            this.block2();
                        }
                        break;
                    case 6:
                        this.enterOuterAlt(_localctx, 6);
                        {
                            this.state = 142;
                            this.block3();
                        }
                        break;
                    case 7:
                        this.enterOuterAlt(_localctx, 7);
                        {
                            this.state = 143;
                            this.block4();
                        }
                        break;
                    case 8:
                        this.enterOuterAlt(_localctx, 8);
                        {
                            this.state = 144;
                            this.block5();
                        }
                        break;
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        block2() {
            let _localctx = new Block2Context(this._ctx, this.state);
            this.enterRule(_localctx, 16, KojiParser.RULE_block2);
            let _la;
            try {
                let _alt;
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 147;
                    this.match(KojiParser.OpenBlock2);
                    this.state = 148;
                    this.match(KojiParser.ElemName);
                    this.state = 150;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.ID) {
                        {
                            this.state = 149;
                            this.match(KojiParser.ID);
                        }
                    }
                    this.state = 155;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while (_la === KojiParser.Class) {
                        {
                            {
                                this.state = 152;
                                this.match(KojiParser.Class);
                            }
                        }
                        this.state = 157;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 158;
                    this.match(KojiParser.HeaderLb);
                    this.state = 162;
                    this._errHandler.sync(this);
                    _alt = this.interpreter.adaptivePredict(this._input, 15, this._ctx);
                    while (_alt !== 2 && _alt !== ATN_1.ATN.INVALID_ALT_NUMBER) {
                        if (_alt === 1) {
                            {
                                {
                                    this.state = 159;
                                    _localctx._blockContent2 = this.blockContent2();
                                    _localctx._content.push(_localctx._blockContent2);
                                }
                            }
                        }
                        this.state = 164;
                        this._errHandler.sync(this);
                        _alt = this.interpreter.adaptivePredict(this._input, 15, this._ctx);
                    }
                    this.state = 166;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.CloseBlock2) {
                        {
                            this.state = 165;
                            this.match(KojiParser.CloseBlock2);
                        }
                    }
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        blockContent2() {
            let _localctx = new BlockContent2Context(this._ctx, this.state);
            this.enterRule(_localctx, 18, KojiParser.RULE_blockContent2);
            try {
                this.state = 175;
                this._errHandler.sync(this);
                switch (this.interpreter.adaptivePredict(this._input, 17, this._ctx)) {
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        {
                            this.state = 168;
                            this.syntaxSugar();
                        }
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        {
                            this.state = 169;
                            this.textSegment();
                        }
                        break;
                    case 3:
                        this.enterOuterAlt(_localctx, 3);
                        {
                            this.state = 170;
                            this.inline();
                        }
                        break;
                    case 4:
                        this.enterOuterAlt(_localctx, 4);
                        {
                            this.state = 171;
                            this.match(KojiParser.Lb);
                        }
                        break;
                    case 5:
                        this.enterOuterAlt(_localctx, 5);
                        {
                            this.state = 172;
                            this.block3();
                        }
                        break;
                    case 6:
                        this.enterOuterAlt(_localctx, 6);
                        {
                            this.state = 173;
                            this.block4();
                        }
                        break;
                    case 7:
                        this.enterOuterAlt(_localctx, 7);
                        {
                            this.state = 174;
                            this.block5();
                        }
                        break;
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        block3() {
            let _localctx = new Block3Context(this._ctx, this.state);
            this.enterRule(_localctx, 20, KojiParser.RULE_block3);
            let _la;
            try {
                let _alt;
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 177;
                    this.match(KojiParser.OpenBlock3);
                    this.state = 178;
                    this.match(KojiParser.ElemName);
                    this.state = 180;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.ID) {
                        {
                            this.state = 179;
                            this.match(KojiParser.ID);
                        }
                    }
                    this.state = 185;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while (_la === KojiParser.Class) {
                        {
                            {
                                this.state = 182;
                                this.match(KojiParser.Class);
                            }
                        }
                        this.state = 187;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 188;
                    this.match(KojiParser.HeaderLb);
                    this.state = 192;
                    this._errHandler.sync(this);
                    _alt = this.interpreter.adaptivePredict(this._input, 20, this._ctx);
                    while (_alt !== 2 && _alt !== ATN_1.ATN.INVALID_ALT_NUMBER) {
                        if (_alt === 1) {
                            {
                                {
                                    this.state = 189;
                                    _localctx._blockContent3 = this.blockContent3();
                                    _localctx._content.push(_localctx._blockContent3);
                                }
                            }
                        }
                        this.state = 194;
                        this._errHandler.sync(this);
                        _alt = this.interpreter.adaptivePredict(this._input, 20, this._ctx);
                    }
                    this.state = 196;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.CloseBlock3) {
                        {
                            this.state = 195;
                            this.match(KojiParser.CloseBlock3);
                        }
                    }
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        blockContent3() {
            let _localctx = new BlockContent3Context(this._ctx, this.state);
            this.enterRule(_localctx, 22, KojiParser.RULE_blockContent3);
            try {
                this.state = 204;
                this._errHandler.sync(this);
                switch (this.interpreter.adaptivePredict(this._input, 22, this._ctx)) {
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        {
                            this.state = 198;
                            this.syntaxSugar();
                        }
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        {
                            this.state = 199;
                            this.textSegment();
                        }
                        break;
                    case 3:
                        this.enterOuterAlt(_localctx, 3);
                        {
                            this.state = 200;
                            this.inline();
                        }
                        break;
                    case 4:
                        this.enterOuterAlt(_localctx, 4);
                        {
                            this.state = 201;
                            this.match(KojiParser.Lb);
                        }
                        break;
                    case 5:
                        this.enterOuterAlt(_localctx, 5);
                        {
                            this.state = 202;
                            this.block4();
                        }
                        break;
                    case 6:
                        this.enterOuterAlt(_localctx, 6);
                        {
                            this.state = 203;
                            this.block5();
                        }
                        break;
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        block4() {
            let _localctx = new Block4Context(this._ctx, this.state);
            this.enterRule(_localctx, 24, KojiParser.RULE_block4);
            let _la;
            try {
                let _alt;
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 206;
                    this.match(KojiParser.OpenBlock4);
                    this.state = 207;
                    this.match(KojiParser.ElemName);
                    this.state = 209;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.ID) {
                        {
                            this.state = 208;
                            this.match(KojiParser.ID);
                        }
                    }
                    this.state = 214;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while (_la === KojiParser.Class) {
                        {
                            {
                                this.state = 211;
                                this.match(KojiParser.Class);
                            }
                        }
                        this.state = 216;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 217;
                    this.match(KojiParser.HeaderLb);
                    this.state = 221;
                    this._errHandler.sync(this);
                    _alt = this.interpreter.adaptivePredict(this._input, 25, this._ctx);
                    while (_alt !== 2 && _alt !== ATN_1.ATN.INVALID_ALT_NUMBER) {
                        if (_alt === 1) {
                            {
                                {
                                    this.state = 218;
                                    _localctx._blockContent4 = this.blockContent4();
                                    _localctx._content.push(_localctx._blockContent4);
                                }
                            }
                        }
                        this.state = 223;
                        this._errHandler.sync(this);
                        _alt = this.interpreter.adaptivePredict(this._input, 25, this._ctx);
                    }
                    this.state = 225;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.CloseBlock4) {
                        {
                            this.state = 224;
                            this.match(KojiParser.CloseBlock4);
                        }
                    }
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        blockContent4() {
            let _localctx = new BlockContent4Context(this._ctx, this.state);
            this.enterRule(_localctx, 26, KojiParser.RULE_blockContent4);
            try {
                this.state = 232;
                this._errHandler.sync(this);
                switch (this.interpreter.adaptivePredict(this._input, 27, this._ctx)) {
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        {
                            this.state = 227;
                            this.syntaxSugar();
                        }
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        {
                            this.state = 228;
                            this.textSegment();
                        }
                        break;
                    case 3:
                        this.enterOuterAlt(_localctx, 3);
                        {
                            this.state = 229;
                            this.inline();
                        }
                        break;
                    case 4:
                        this.enterOuterAlt(_localctx, 4);
                        {
                            this.state = 230;
                            this.match(KojiParser.Lb);
                        }
                        break;
                    case 5:
                        this.enterOuterAlt(_localctx, 5);
                        {
                            this.state = 231;
                            this.block5();
                        }
                        break;
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        block5() {
            let _localctx = new Block5Context(this._ctx, this.state);
            this.enterRule(_localctx, 28, KojiParser.RULE_block5);
            let _la;
            try {
                let _alt;
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 234;
                    this.match(KojiParser.OpenBlock5);
                    this.state = 235;
                    this.match(KojiParser.ElemName);
                    this.state = 237;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.ID) {
                        {
                            this.state = 236;
                            this.match(KojiParser.ID);
                        }
                    }
                    this.state = 242;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while (_la === KojiParser.Class) {
                        {
                            {
                                this.state = 239;
                                this.match(KojiParser.Class);
                            }
                        }
                        this.state = 244;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 245;
                    this.match(KojiParser.HeaderLb);
                    this.state = 249;
                    this._errHandler.sync(this);
                    _alt = this.interpreter.adaptivePredict(this._input, 30, this._ctx);
                    while (_alt !== 2 && _alt !== ATN_1.ATN.INVALID_ALT_NUMBER) {
                        if (_alt === 1) {
                            {
                                {
                                    this.state = 246;
                                    _localctx._blockContent5 = this.blockContent5();
                                    _localctx._content.push(_localctx._blockContent5);
                                }
                            }
                        }
                        this.state = 251;
                        this._errHandler.sync(this);
                        _alt = this.interpreter.adaptivePredict(this._input, 30, this._ctx);
                    }
                    this.state = 253;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.CloseBlock5) {
                        {
                            this.state = 252;
                            this.match(KojiParser.CloseBlock5);
                        }
                    }
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        blockContent5() {
            let _localctx = new BlockContent5Context(this._ctx, this.state);
            this.enterRule(_localctx, 30, KojiParser.RULE_blockContent5);
            try {
                this.state = 259;
                this._errHandler.sync(this);
                switch (this.interpreter.adaptivePredict(this._input, 32, this._ctx)) {
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        {
                            this.state = 255;
                            this.syntaxSugar();
                        }
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        {
                            this.state = 256;
                            this.textSegment();
                        }
                        break;
                    case 3:
                        this.enterOuterAlt(_localctx, 3);
                        {
                            this.state = 257;
                            this.inline();
                        }
                        break;
                    case 4:
                        this.enterOuterAlt(_localctx, 4);
                        {
                            this.state = 258;
                            this.match(KojiParser.Lb);
                        }
                        break;
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        textSegment() {
            let _localctx = new TextSegmentContext(this._ctx, this.state);
            this.enterRule(_localctx, 32, KojiParser.RULE_textSegment);
            let _la;
            try {
                let _alt;
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 262;
                    this._errHandler.sync(this);
                    _alt = 1;
                    do {
                        switch (_alt) {
                            case 1:
                                {
                                    {
                                        this.state = 261;
                                        _la = this._input.LA(1);
                                        if (!((((_la) & ~0x1F) === 0 && ((1 << _la) & ((1 << KojiParser.NonJp) | (1 << KojiParser.Kanji) | (1 << KojiParser.Kana))) !== 0))) {
                                            this._errHandler.recoverInline(this);
                                        }
                                        else {
                                            if (this._input.LA(1) === Token_1.Token.EOF) {
                                                this.matchedEOF = true;
                                            }
                                            this._errHandler.reportMatch(this);
                                            this.consume();
                                        }
                                    }
                                }
                                break;
                            default:
                                throw new NoViableAltException_1.NoViableAltException(this);
                        }
                        this.state = 264;
                        this._errHandler.sync(this);
                        _alt = this.interpreter.adaptivePredict(this._input, 33, this._ctx);
                    } while (_alt !== 2 && _alt !== ATN_1.ATN.INVALID_ALT_NUMBER);
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        postPositionedAttrs() {
            let _localctx = new PostPositionedAttrsContext(this._ctx, this.state);
            this.enterRule(_localctx, 34, KojiParser.RULE_postPositionedAttrs);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 266;
                    this.match(KojiParser.AttrsOpen);
                    this.state = 268;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.ID) {
                        {
                            this.state = 267;
                            this.match(KojiParser.ID);
                        }
                    }
                    this.state = 273;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while (_la === KojiParser.Class) {
                        {
                            {
                                this.state = 270;
                                this.match(KojiParser.Class);
                            }
                        }
                        this.state = 275;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    this.state = 276;
                    this.match(KojiParser.AttrsClose);
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        syntaxSugar() {
            let _localctx = new SyntaxSugarContext(this._ctx, this.state);
            this.enterRule(_localctx, 36, KojiParser.RULE_syntaxSugar);
            try {
                this.state = 288;
                this._errHandler.sync(this);
                switch (this.interpreter.adaptivePredict(this._input, 36, this._ctx)) {
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        {
                            this.state = 278;
                            this.furigana();
                        }
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        {
                            this.state = 279;
                            this.kaeriten();
                        }
                        break;
                    case 3:
                        this.enterOuterAlt(_localctx, 3);
                        {
                            this.state = 280;
                            this.okurigana();
                        }
                        break;
                    case 4:
                        this.enterOuterAlt(_localctx, 4);
                        {
                            this.state = 281;
                            this.tateten();
                        }
                        break;
                    case 5:
                        this.enterOuterAlt(_localctx, 5);
                        {
                            this.state = 282;
                            this.annotation();
                        }
                        break;
                    case 6:
                        this.enterOuterAlt(_localctx, 6);
                        {
                            this.state = 283;
                            this.illegible();
                        }
                        break;
                    case 7:
                        this.enterOuterAlt(_localctx, 7);
                        {
                            this.state = 284;
                            this.bugHole();
                        }
                        break;
                    case 8:
                        this.enterOuterAlt(_localctx, 8);
                        {
                            this.state = 285;
                            this.person();
                        }
                        break;
                    case 9:
                        this.enterOuterAlt(_localctx, 9);
                        {
                            this.state = 286;
                            this.place();
                        }
                        break;
                    case 10:
                        this.enterOuterAlt(_localctx, 10);
                        {
                            this.state = 287;
                            this.date();
                        }
                        break;
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        furiganaTarget() {
            let _localctx = new FuriganaTargetContext(this._ctx, this.state);
            this.enterRule(_localctx, 38, KojiParser.RULE_furiganaTarget);
            try {
                this.state = 296;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case KojiParser.Kanji:
                        this.enterOuterAlt(_localctx, 1);
                        {
                            this.state = 290;
                            this.match(KojiParser.Kanji);
                        }
                        break;
                    case KojiParser.Kana:
                        this.enterOuterAlt(_localctx, 2);
                        {
                            this.state = 291;
                            this.match(KojiParser.Kana);
                        }
                        break;
                    case KojiParser.NonJp:
                        this.enterOuterAlt(_localctx, 3);
                        {
                            this.state = 292;
                            this.match(KojiParser.NonJp);
                        }
                        break;
                    case KojiParser.AnnotationOpen:
                        this.enterOuterAlt(_localctx, 4);
                        {
                            this.state = 293;
                            this.annotation();
                        }
                        break;
                    case KojiParser.IllegibleMark:
                        this.enterOuterAlt(_localctx, 5);
                        {
                            this.state = 294;
                            this.illegible();
                        }
                        break;
                    case KojiParser.BugHoleMark:
                        this.enterOuterAlt(_localctx, 6);
                        {
                            this.state = 295;
                            this.bugHole();
                        }
                        break;
                    default:
                        throw new NoViableAltException_1.NoViableAltException(this);
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        furigana() {
            let _localctx = new FuriganaContext(this._ctx, this.state);
            this.enterRule(_localctx, 40, KojiParser.RULE_furigana);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 299;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.FuriganaPre) {
                        {
                            this.state = 298;
                            this.match(KojiParser.FuriganaPre);
                        }
                    }
                    {
                        this.state = 301;
                        _localctx._target = this.furiganaTarget();
                    }
                    this.state = 302;
                    this.match(KojiParser.FuriganaOpen);
                    this.state = 303;
                    _localctx._right = this.match(KojiParser.FuriganaContent);
                    this.state = 306;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.FuriganaSep) {
                        {
                            this.state = 304;
                            this.match(KojiParser.FuriganaSep);
                            this.state = 305;
                            _localctx._left = this.match(KojiParser.FuriganaContent);
                        }
                    }
                    this.state = 308;
                    this.match(KojiParser.FuriganaClose);
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        kaeriten() {
            let _localctx = new KaeritenContext(this._ctx, this.state);
            this.enterRule(_localctx, 42, KojiParser.RULE_kaeriten);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 310;
                    this.match(KojiParser.KaeritenMark);
                    this.state = 312;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    do {
                        {
                            {
                                this.state = 311;
                                _localctx._content = this.match(KojiParser.KaeritenChar);
                            }
                        }
                        this.state = 314;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    } while (_la === KojiParser.KaeritenChar);
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        okurigana() {
            let _localctx = new OkuriganaContext(this._ctx, this.state);
            this.enterRule(_localctx, 44, KojiParser.RULE_okurigana);
            try {
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 316;
                    this.match(KojiParser.OkuriganaMark);
                    this.state = 317;
                    _localctx._content = this.match(KojiParser.Kana);
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        tateten() {
            let _localctx = new TatetenContext(this._ctx, this.state);
            this.enterRule(_localctx, 46, KojiParser.RULE_tateten);
            try {
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 319;
                    this.match(KojiParser.TatetenChar);
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        annotation() {
            let _localctx = new AnnotationContext(this._ctx, this.state);
            this.enterRule(_localctx, 48, KojiParser.RULE_annotation);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 321;
                    this.match(KojiParser.AnnotationOpen);
                    this.state = 322;
                    _localctx._content = this.match(KojiParser.AnnotationContent);
                    this.state = 323;
                    _la = this._input.LA(1);
                    if (!(_la === KojiParser.EOF || _la === KojiParser.AnnotationClose)) {
                        this._errHandler.recoverInline(this);
                    }
                    else {
                        if (this._input.LA(1) === Token_1.Token.EOF) {
                            this.matchedEOF = true;
                        }
                        this._errHandler.reportMatch(this);
                        this.consume();
                    }
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        illegible() {
            let _localctx = new IllegibleContext(this._ctx, this.state);
            this.enterRule(_localctx, 50, KojiParser.RULE_illegible);
            try {
                let _alt;
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 326;
                    this._errHandler.sync(this);
                    _alt = 1;
                    do {
                        switch (_alt) {
                            case 1:
                                {
                                    {
                                        this.state = 325;
                                        this.match(KojiParser.IllegibleMark);
                                    }
                                }
                                break;
                            default:
                                throw new NoViableAltException_1.NoViableAltException(this);
                        }
                        this.state = 328;
                        this._errHandler.sync(this);
                        _alt = this.interpreter.adaptivePredict(this._input, 41, this._ctx);
                    } while (_alt !== 2 && _alt !== ATN_1.ATN.INVALID_ALT_NUMBER);
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        bugHole() {
            let _localctx = new BugHoleContext(this._ctx, this.state);
            this.enterRule(_localctx, 52, KojiParser.RULE_bugHole);
            try {
                let _alt;
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 331;
                    this._errHandler.sync(this);
                    _alt = 1;
                    do {
                        switch (_alt) {
                            case 1:
                                {
                                    {
                                        this.state = 330;
                                        this.match(KojiParser.BugHoleMark);
                                    }
                                }
                                break;
                            default:
                                throw new NoViableAltException_1.NoViableAltException(this);
                        }
                        this.state = 333;
                        this._errHandler.sync(this);
                        _alt = this.interpreter.adaptivePredict(this._input, 42, this._ctx);
                    } while (_alt !== 2 && _alt !== ATN_1.ATN.INVALID_ALT_NUMBER);
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        person() {
            let _localctx = new PersonContext(this._ctx, this.state);
            this.enterRule(_localctx, 54, KojiParser.RULE_person);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 335;
                    this.match(KojiParser.PersonOpen);
                    this.state = 337;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    do {
                        {
                            {
                                this.state = 336;
                                _localctx._inlineContent = this.inlineContent();
                                _localctx._content.push(_localctx._inlineContent);
                            }
                        }
                        this.state = 339;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    } while (((((_la - 11)) & ~0x1F) === 0 && ((1 << (_la - 11)) & ((1 << (KojiParser.OpenInline - 11)) | (1 << (KojiParser.FuriganaPre - 11)) | (1 << (KojiParser.AnnotationOpen - 11)) | (1 << (KojiParser.PersonOpen - 11)) | (1 << (KojiParser.PlaceOpen - 11)) | (1 << (KojiParser.DateOpen - 11)) | (1 << (KojiParser.KaeritenMark - 11)) | (1 << (KojiParser.TatetenChar - 11)) | (1 << (KojiParser.OkuriganaMark - 11)) | (1 << (KojiParser.IllegibleMark - 11)) | (1 << (KojiParser.BugHoleMark - 11)) | (1 << (KojiParser.NonJp - 11)) | (1 << (KojiParser.Kanji - 11)) | (1 << (KojiParser.Kana - 11)) | (1 << (KojiParser.Lb - 11)))) !== 0));
                    this.state = 341;
                    this.match(KojiParser.PersonClose);
                    this.state = 343;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.AttrsOpen) {
                        {
                            this.state = 342;
                            this.postPositionedAttrs();
                        }
                    }
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        place() {
            let _localctx = new PlaceContext(this._ctx, this.state);
            this.enterRule(_localctx, 56, KojiParser.RULE_place);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 345;
                    this.match(KojiParser.PlaceOpen);
                    this.state = 347;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    do {
                        {
                            {
                                this.state = 346;
                                _localctx._inlineContent = this.inlineContent();
                                _localctx._content.push(_localctx._inlineContent);
                            }
                        }
                        this.state = 349;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    } while (((((_la - 11)) & ~0x1F) === 0 && ((1 << (_la - 11)) & ((1 << (KojiParser.OpenInline - 11)) | (1 << (KojiParser.FuriganaPre - 11)) | (1 << (KojiParser.AnnotationOpen - 11)) | (1 << (KojiParser.PersonOpen - 11)) | (1 << (KojiParser.PlaceOpen - 11)) | (1 << (KojiParser.DateOpen - 11)) | (1 << (KojiParser.KaeritenMark - 11)) | (1 << (KojiParser.TatetenChar - 11)) | (1 << (KojiParser.OkuriganaMark - 11)) | (1 << (KojiParser.IllegibleMark - 11)) | (1 << (KojiParser.BugHoleMark - 11)) | (1 << (KojiParser.NonJp - 11)) | (1 << (KojiParser.Kanji - 11)) | (1 << (KojiParser.Kana - 11)) | (1 << (KojiParser.Lb - 11)))) !== 0));
                    this.state = 351;
                    this.match(KojiParser.PlaceClose);
                    this.state = 353;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.AttrsOpen) {
                        {
                            this.state = 352;
                            this.postPositionedAttrs();
                        }
                    }
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        // @RuleVersion(0)
        date() {
            let _localctx = new DateContext(this._ctx, this.state);
            this.enterRule(_localctx, 58, KojiParser.RULE_date);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                {
                    this.state = 355;
                    this.match(KojiParser.DateOpen);
                    this.state = 357;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    do {
                        {
                            {
                                this.state = 356;
                                _localctx._inlineContent = this.inlineContent();
                                _localctx._content.push(_localctx._inlineContent);
                            }
                        }
                        this.state = 359;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    } while (((((_la - 11)) & ~0x1F) === 0 && ((1 << (_la - 11)) & ((1 << (KojiParser.OpenInline - 11)) | (1 << (KojiParser.FuriganaPre - 11)) | (1 << (KojiParser.AnnotationOpen - 11)) | (1 << (KojiParser.PersonOpen - 11)) | (1 << (KojiParser.PlaceOpen - 11)) | (1 << (KojiParser.DateOpen - 11)) | (1 << (KojiParser.KaeritenMark - 11)) | (1 << (KojiParser.TatetenChar - 11)) | (1 << (KojiParser.OkuriganaMark - 11)) | (1 << (KojiParser.IllegibleMark - 11)) | (1 << (KojiParser.BugHoleMark - 11)) | (1 << (KojiParser.NonJp - 11)) | (1 << (KojiParser.Kanji - 11)) | (1 << (KojiParser.Kana - 11)) | (1 << (KojiParser.Lb - 11)))) !== 0));
                    this.state = 361;
                    this.match(KojiParser.DateClose);
                    this.state = 363;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    if (_la === KojiParser.AttrsOpen) {
                        {
                            this.state = 362;
                            this.postPositionedAttrs();
                        }
                    }
                }
            }
            catch (re) {
                if (re instanceof RecognitionException_1.RecognitionException) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                }
                else {
                    throw re;
                }
            }
            finally {
                this.exitRule();
            }
            return _localctx;
        }
        static get _ATN() {
            if (!KojiParser.__ATN) {
                KojiParser.__ATN = new ATNDeserializer_1.ATNDeserializer().deserialize(Utils.toCharArray(KojiParser._serializedATN));
            }
            return KojiParser.__ATN;
        }
    }
    KojiParser.OpenBlock1 = 1;
    KojiParser.CloseBlock1 = 2;
    KojiParser.OpenBlock2 = 3;
    KojiParser.CloseBlock2 = 4;
    KojiParser.OpenBlock3 = 5;
    KojiParser.CloseBlock3 = 6;
    KojiParser.OpenBlock4 = 7;
    KojiParser.CloseBlock4 = 8;
    KojiParser.OpenBlock5 = 9;
    KojiParser.CloseBlock5 = 10;
    KojiParser.OpenInline = 11;
    KojiParser.CloseInline = 12;
    KojiParser.Bar = 13;
    KojiParser.FuriganaPre = 14;
    KojiParser.FuriganaOpen = 15;
    KojiParser.AnnotationOpen = 16;
    KojiParser.PersonOpen = 17;
    KojiParser.PersonClose = 18;
    KojiParser.PlaceOpen = 19;
    KojiParser.PlaceClose = 20;
    KojiParser.DateOpen = 21;
    KojiParser.DateClose = 22;
    KojiParser.AttrsOpen = 23;
    KojiParser.KaeritenMark = 24;
    KojiParser.TatetenChar = 25;
    KojiParser.OkuriganaMark = 26;
    KojiParser.IllegibleMark = 27;
    KojiParser.BugHoleMark = 28;
    KojiParser.NonJp = 29;
    KojiParser.Kanji = 30;
    KojiParser.Kana = 31;
    KojiParser.NonJpChar = 32;
    KojiParser.KanjiChar = 33;
    KojiParser.Lb = 34;
    KojiParser.WS = 35;
    KojiParser.ElemName = 36;
    KojiParser.Colon = 37;
    KojiParser.HeaderLb = 38;
    KojiParser.AttrsClose = 39;
    KojiParser.ID = 40;
    KojiParser.Class = 41;
    KojiParser.FuriganaContent = 42;
    KojiParser.FuriganaSep = 43;
    KojiParser.FuriganaClose = 44;
    KojiParser.KaeritenChar = 45;
    KojiParser.AnnotationContent = 46;
    KojiParser.AnnotationClose = 47;
    KojiParser.RULE_koji = 0;
    KojiParser.RULE_list = 1;
    KojiParser.RULE_inline = 2;
    KojiParser.RULE_inlineContentSeq = 3;
    KojiParser.RULE_inlineContent = 4;
    KojiParser.RULE_block = 5;
    KojiParser.RULE_block1 = 6;
    KojiParser.RULE_blockContent1 = 7;
    KojiParser.RULE_block2 = 8;
    KojiParser.RULE_blockContent2 = 9;
    KojiParser.RULE_block3 = 10;
    KojiParser.RULE_blockContent3 = 11;
    KojiParser.RULE_block4 = 12;
    KojiParser.RULE_blockContent4 = 13;
    KojiParser.RULE_block5 = 14;
    KojiParser.RULE_blockContent5 = 15;
    KojiParser.RULE_textSegment = 16;
    KojiParser.RULE_postPositionedAttrs = 17;
    KojiParser.RULE_syntaxSugar = 18;
    KojiParser.RULE_furiganaTarget = 19;
    KojiParser.RULE_furigana = 20;
    KojiParser.RULE_kaeriten = 21;
    KojiParser.RULE_okurigana = 22;
    KojiParser.RULE_tateten = 23;
    KojiParser.RULE_annotation = 24;
    KojiParser.RULE_illegible = 25;
    KojiParser.RULE_bugHole = 26;
    KojiParser.RULE_person = 27;
    KojiParser.RULE_place = 28;
    KojiParser.RULE_date = 29;
    // tslint:disable:no-trailing-whitespace
    KojiParser.ruleNames = [
        "koji", "list", "inline", "inlineContentSeq", "inlineContent", "block",
        "block1", "blockContent1", "block2", "blockContent2", "block3", "blockContent3",
        "block4", "blockContent4", "block5", "blockContent5", "textSegment", "postPositionedAttrs",
        "syntaxSugar", "furiganaTarget", "furigana", "kaeriten", "okurigana",
        "tateten", "annotation", "illegible", "bugHole", "person", "place", "date",
    ];
    KojiParser._LITERAL_NAMES = [
        undefined, "'\uFF05'", "'\n\n'", "'\uFF05\uFF05'", "'\n\uFF05\n'", "'\uFF05\uFF05\uFF05'",
        "'\n\uFF05\uFF05\n'", "'\uFF05\uFF05\uFF05\uFF05'", "'\n\uFF05\uFF05\uFF05\n'",
        "'\uFF05\uFF05\uFF05\uFF05\uFF05'", "'\n\uFF05\uFF05\uFF05\uFF05\n'",
        "'\u300A'", "'\u300B'", undefined, "'\uFF0F'", "'\uFF08'", "'\u3010'",
        "'\uFF5B'", "'\uFF5D'", "'\u3014'", "'\u3015'", "'\uFF1C'", "'\uFF1E'",
        "'\uFF3B'", "'\uFF3F'", undefined, "'\uFFE3'", "'\u25A0'", "'\u25A1'",
        undefined, undefined, undefined, undefined, undefined, undefined, undefined,
        undefined, "'\uFF1A'", undefined, "'\uFF3D'", undefined, undefined, undefined,
        undefined, "'\uFF09'",
    ];
    KojiParser._SYMBOLIC_NAMES = [
        undefined, "OpenBlock1", "CloseBlock1", "OpenBlock2", "CloseBlock2", "OpenBlock3",
        "CloseBlock3", "OpenBlock4", "CloseBlock4", "OpenBlock5", "CloseBlock5",
        "OpenInline", "CloseInline", "Bar", "FuriganaPre", "FuriganaOpen", "AnnotationOpen",
        "PersonOpen", "PersonClose", "PlaceOpen", "PlaceClose", "DateOpen", "DateClose",
        "AttrsOpen", "KaeritenMark", "TatetenChar", "OkuriganaMark", "IllegibleMark",
        "BugHoleMark", "NonJp", "Kanji", "Kana", "NonJpChar", "KanjiChar", "Lb",
        "WS", "ElemName", "Colon", "HeaderLb", "AttrsClose", "ID", "Class", "FuriganaContent",
        "FuriganaSep", "FuriganaClose", "KaeritenChar", "AnnotationContent", "AnnotationClose",
    ];
    KojiParser.VOCABULARY = new VocabularyImpl_1.VocabularyImpl(KojiParser._LITERAL_NAMES, KojiParser._SYMBOLIC_NAMES, []);
    KojiParser._serializedATN = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x031\u0170\x04\x02" +
        "\t\x02\x04\x03\t\x03\x04\x04\t\x04\x04\x05\t\x05\x04\x06\t\x06\x04\x07" +
        "\t\x07\x04\b\t\b\x04\t\t\t\x04\n\t\n\x04\v\t\v\x04\f\t\f\x04\r\t\r\x04" +
        "\x0E\t\x0E\x04\x0F\t\x0F\x04\x10\t\x10\x04\x11\t\x11\x04\x12\t\x12\x04" +
        "\x13\t\x13\x04\x14\t\x14\x04\x15\t\x15\x04\x16\t\x16\x04\x17\t\x17\x04" +
        "\x18\t\x18\x04\x19\t\x19\x04\x1A\t\x1A\x04\x1B\t\x1B\x04\x1C\t\x1C\x04" +
        "\x1D\t\x1D\x04\x1E\t\x1E\x04\x1F\t\x1F\x03\x02\x07\x02@\n\x02\f\x02\x0E" +
        "\x02C\v\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x03\x03\x03\x03\x03\x05" +
        "\x03L\n\x03\x03\x04\x03\x04\x03\x04\x05\x04Q\n\x04\x03\x04\x07\x04T\n" +
        "\x04\f\x04\x0E\x04W\v\x04\x03\x04\x03\x04\x03\x04\x03\x04\x07\x04]\n\x04" +
        "\f\x04\x0E\x04`\v\x04\x03\x04\x03\x04\x03\x05\x07\x05e\n\x05\f\x05\x0E" +
        "\x05h\v\x05\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06n\n\x06\x03\x07\x03" +
        "\x07\x03\x07\x03\x07\x03\x07\x05\x07u\n\x07\x03\b\x03\b\x03\b\x05\bz\n" +
        "\b\x03\b\x07\b}\n\b\f\b\x0E\b\x80\v\b\x03\b\x03\b\x07\b\x84\n\b\f\b\x0E" +
        "\b\x87\v\b\x03\b\x05\b\x8A\n\b\x03\t\x03\t\x03\t\x03\t\x03\t\x03\t\x03" +
        "\t\x03\t\x05\t\x94\n\t\x03\n\x03\n\x03\n\x05\n\x99\n\n\x03\n\x07\n\x9C" +
        "\n\n\f\n\x0E\n\x9F\v\n\x03\n\x03\n\x07\n\xA3\n\n\f\n\x0E\n\xA6\v\n\x03" +
        "\n\x05\n\xA9\n\n\x03\v\x03\v\x03\v\x03\v\x03\v\x03\v\x03\v\x05\v\xB2\n" +
        "\v\x03\f\x03\f\x03\f\x05\f\xB7\n\f\x03\f\x07\f\xBA\n\f\f\f\x0E\f\xBD\v" +
        "\f\x03\f\x03\f\x07\f\xC1\n\f\f\f\x0E\f\xC4\v\f\x03\f\x05\f\xC7\n\f\x03" +
        "\r\x03\r\x03\r\x03\r\x03\r\x03\r\x05\r\xCF\n\r\x03\x0E\x03\x0E\x03\x0E" +
        "\x05\x0E\xD4\n\x0E\x03\x0E\x07\x0E\xD7\n\x0E\f\x0E\x0E\x0E\xDA\v\x0E\x03" +
        "\x0E\x03\x0E\x07\x0E\xDE\n\x0E\f\x0E\x0E\x0E\xE1\v\x0E\x03\x0E\x05\x0E" +
        "\xE4\n\x0E\x03\x0F\x03\x0F\x03\x0F\x03\x0F\x03\x0F\x05\x0F\xEB\n\x0F\x03" +
        "\x10\x03\x10\x03\x10\x05\x10\xF0\n\x10\x03\x10\x07\x10\xF3\n\x10\f\x10" +
        "\x0E\x10\xF6\v\x10\x03\x10\x03\x10\x07\x10\xFA\n\x10\f\x10\x0E\x10\xFD" +
        "\v\x10\x03\x10\x05\x10\u0100\n\x10\x03\x11\x03\x11\x03\x11\x03\x11\x05" +
        "\x11\u0106\n\x11\x03\x12\x06\x12\u0109\n\x12\r\x12\x0E\x12\u010A\x03\x13" +
        "\x03\x13\x05\x13\u010F\n\x13\x03\x13\x07\x13\u0112\n\x13\f\x13\x0E\x13" +
        "\u0115\v\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03" +
        "\x14\x03\x14\x03\x14\x03\x14\x03\x14\x05\x14\u0123\n\x14\x03\x15\x03\x15" +
        "\x03\x15\x03\x15\x03\x15\x03\x15\x05\x15\u012B\n\x15\x03\x16\x05\x16\u012E" +
        "\n\x16\x03\x16\x03\x16\x03\x16\x03\x16\x03\x16\x05\x16\u0135\n\x16\x03" +
        "\x16\x03\x16\x03\x17\x03\x17\x06\x17\u013B\n\x17\r\x17\x0E\x17\u013C\x03" +
        "\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x1A\x03\x1A\x03\x1A\x03\x1A\x03" +
        "\x1B\x06\x1B\u0149\n\x1B\r\x1B\x0E\x1B\u014A\x03\x1C\x06\x1C\u014E\n\x1C" +
        "\r\x1C\x0E\x1C\u014F\x03\x1D\x03\x1D\x06\x1D\u0154\n\x1D\r\x1D\x0E\x1D" +
        "\u0155\x03\x1D\x03\x1D\x05\x1D\u015A\n\x1D\x03\x1E\x03\x1E\x06\x1E\u015E" +
        "\n\x1E\r\x1E\x0E\x1E\u015F\x03\x1E\x03\x1E\x05\x1E\u0164\n\x1E\x03\x1F" +
        "\x03\x1F\x06\x1F\u0168\n\x1F\r\x1F\x0E\x1F\u0169\x03\x1F\x03\x1F\x05\x1F" +
        "\u016E\n\x1F\x03\x1F\x02\x02\x02 \x02\x02\x04\x02\x06\x02\b\x02\n\x02" +
        "\f\x02\x0E\x02\x10\x02\x12\x02\x14\x02\x16\x02\x18\x02\x1A\x02\x1C\x02" +
        "\x1E\x02 \x02\"\x02$\x02&\x02(\x02*\x02,\x02.\x020\x022\x024\x026\x02" +
        "8\x02:\x02<\x02\x02\x04\x03\x02\x1F!\x03\x0311\x02\u01AA\x02A\x03\x02" +
        "\x02\x02\x04K\x03\x02\x02\x02\x06M\x03\x02\x02\x02\bf\x03\x02\x02\x02" +
        "\nm\x03\x02\x02\x02\ft\x03\x02\x02\x02\x0Ev\x03\x02\x02\x02\x10\x93\x03" +
        "\x02\x02\x02\x12\x95\x03\x02\x02\x02\x14\xB1\x03\x02\x02\x02\x16\xB3\x03" +
        "\x02\x02\x02\x18\xCE\x03\x02\x02\x02\x1A\xD0\x03\x02\x02\x02\x1C\xEA\x03" +
        "\x02\x02\x02\x1E\xEC\x03\x02\x02\x02 \u0105\x03\x02\x02\x02\"\u0108\x03" +
        "\x02\x02\x02$\u010C\x03\x02\x02\x02&\u0122\x03\x02\x02\x02(\u012A\x03" +
        "\x02\x02\x02*\u012D\x03\x02\x02\x02,\u0138\x03\x02\x02\x02.\u013E\x03" +
        "\x02\x02\x020\u0141\x03\x02\x02\x022\u0143\x03\x02\x02\x024\u0148\x03" +
        "\x02\x02\x026\u014D\x03\x02\x02\x028\u0151\x03\x02\x02\x02:\u015B\x03" +
        "\x02\x02\x02<\u0165\x03\x02\x02\x02>@\x05\x04\x03\x02?>\x03\x02\x02\x02" +
        "@C\x03\x02\x02\x02A?\x03\x02\x02\x02AB\x03\x02\x02\x02BD\x03\x02\x02\x02" +
        "CA\x03\x02\x02\x02DE\x07\x02\x02\x03E\x03\x03\x02\x02\x02FL\x05\f\x07" +
        "\x02GL\x05\x06\x04\x02HL\x05&\x14\x02IL\x05\"\x12\x02JL\x07$\x02\x02K" +
        "F\x03\x02\x02\x02KG\x03\x02\x02\x02KH\x03\x02\x02\x02KI\x03\x02\x02\x02" +
        "KJ\x03\x02\x02\x02L\x05\x03\x02\x02\x02MN\x07\r\x02\x02NP\x07&\x02\x02" +
        "OQ\x07*\x02\x02PO\x03\x02\x02\x02PQ\x03\x02\x02\x02QU\x03\x02\x02\x02" +
        "RT\x07+\x02\x02SR\x03\x02\x02\x02TW\x03\x02\x02\x02US\x03\x02\x02\x02" +
        "UV\x03\x02\x02\x02VX\x03\x02\x02\x02WU\x03\x02\x02\x02XY\x07\'\x02\x02" +
        "Y^\x05\b\x05\x02Z[\x07\x0F\x02\x02[]\x05\b\x05\x02\\Z\x03\x02\x02\x02" +
        "]`\x03\x02\x02\x02^\\\x03\x02\x02\x02^_\x03\x02\x02\x02_a\x03\x02\x02" +
        "\x02`^\x03\x02\x02\x02ab\x07\x0E\x02\x02b\x07\x03\x02\x02\x02ce\x05\n" +
        "\x06\x02dc\x03\x02\x02\x02eh\x03\x02\x02\x02fd\x03\x02\x02\x02fg\x03\x02" +
        "\x02\x02g\t\x03\x02\x02\x02hf\x03\x02\x02\x02in\x05&\x14\x02jn\x05\"\x12" +
        "\x02kn\x05\x06\x04\x02ln\x07$\x02\x02mi\x03\x02\x02\x02mj\x03\x02\x02" +
        "\x02mk\x03\x02\x02\x02ml\x03\x02\x02\x02n\v\x03\x02\x02\x02ou\x05\x0E" +
        "\b\x02pu\x05\x12\n\x02qu\x05\x16\f\x02ru\x05\x1A\x0E\x02su\x05\x1E\x10" +
        "\x02to\x03\x02\x02\x02tp\x03\x02\x02\x02tq\x03\x02\x02\x02tr\x03\x02\x02" +
        "\x02ts\x03\x02\x02\x02u\r\x03\x02\x02\x02vw\x07\x03\x02\x02wy\x07&\x02" +
        "\x02xz\x07*\x02\x02yx\x03\x02\x02\x02yz\x03\x02\x02\x02z~\x03\x02\x02" +
        "\x02{}\x07+\x02\x02|{\x03\x02\x02\x02}\x80\x03\x02\x02\x02~|\x03\x02\x02" +
        "\x02~\x7F\x03\x02\x02\x02\x7F\x81\x03\x02\x02\x02\x80~\x03\x02\x02\x02" +
        "\x81\x85\x07(\x02\x02\x82\x84\x05\x10\t\x02\x83\x82\x03\x02\x02\x02\x84" +
        "\x87\x03\x02\x02\x02\x85\x83\x03\x02\x02\x02\x85\x86\x03\x02\x02\x02\x86" +
        "\x89\x03\x02\x02\x02\x87\x85\x03\x02\x02\x02\x88\x8A\x07\x04\x02\x02\x89" +
        "\x88\x03\x02\x02\x02\x89\x8A\x03\x02\x02\x02\x8A\x0F\x03\x02\x02\x02\x8B" +
        "\x94\x05&\x14\x02\x8C\x94\x05\"\x12\x02\x8D\x94\x05\x06\x04\x02\x8E\x94" +
        "\x07$\x02\x02\x8F\x94\x05\x12\n\x02\x90\x94\x05\x16\f\x02\x91\x94\x05" +
        "\x1A\x0E\x02\x92\x94\x05\x1E\x10\x02\x93\x8B\x03\x02\x02\x02\x93\x8C\x03" +
        "\x02\x02\x02\x93\x8D\x03\x02\x02\x02\x93\x8E\x03\x02\x02\x02\x93\x8F\x03" +
        "\x02\x02\x02\x93\x90\x03\x02\x02\x02\x93\x91\x03\x02\x02\x02\x93\x92\x03" +
        "\x02\x02\x02\x94\x11\x03\x02\x02\x02\x95\x96\x07\x05\x02\x02\x96\x98\x07" +
        "&\x02\x02\x97\x99\x07*\x02\x02\x98\x97\x03\x02\x02\x02\x98\x99\x03\x02" +
        "\x02\x02\x99\x9D\x03\x02\x02\x02\x9A\x9C\x07+\x02\x02\x9B\x9A\x03\x02" +
        "\x02\x02\x9C\x9F\x03\x02\x02\x02\x9D\x9B\x03\x02\x02\x02\x9D\x9E\x03\x02" +
        "\x02\x02\x9E\xA0\x03\x02\x02\x02\x9F\x9D\x03\x02\x02\x02\xA0\xA4\x07(" +
        "\x02\x02\xA1\xA3\x05\x14\v\x02\xA2\xA1\x03\x02\x02\x02\xA3\xA6\x03\x02" +
        "\x02\x02\xA4\xA2\x03\x02\x02\x02\xA4\xA5\x03\x02\x02\x02\xA5\xA8\x03\x02" +
        "\x02\x02\xA6\xA4\x03\x02\x02\x02\xA7\xA9\x07\x06\x02\x02\xA8\xA7\x03\x02" +
        "\x02\x02\xA8\xA9\x03\x02\x02\x02\xA9\x13\x03\x02\x02\x02\xAA\xB2\x05&" +
        "\x14\x02\xAB\xB2\x05\"\x12\x02\xAC\xB2\x05\x06\x04\x02\xAD\xB2\x07$\x02" +
        "\x02\xAE\xB2\x05\x16\f\x02\xAF\xB2\x05\x1A\x0E\x02\xB0\xB2\x05\x1E\x10" +
        "\x02\xB1\xAA\x03\x02\x02\x02\xB1\xAB\x03\x02\x02\x02\xB1\xAC\x03\x02\x02" +
        "\x02\xB1\xAD\x03\x02\x02\x02\xB1\xAE\x03\x02\x02\x02\xB1\xAF\x03\x02\x02" +
        "\x02\xB1\xB0\x03\x02\x02\x02\xB2\x15\x03\x02\x02\x02\xB3\xB4\x07\x07\x02" +
        "\x02\xB4\xB6\x07&\x02\x02\xB5\xB7\x07*\x02\x02\xB6\xB5\x03\x02\x02\x02" +
        "\xB6\xB7\x03\x02\x02\x02\xB7\xBB\x03\x02\x02\x02\xB8\xBA\x07+\x02\x02" +
        "\xB9\xB8\x03\x02\x02\x02\xBA\xBD\x03\x02\x02\x02\xBB\xB9\x03\x02\x02\x02" +
        "\xBB\xBC\x03\x02\x02\x02\xBC\xBE\x03\x02\x02\x02\xBD\xBB\x03\x02\x02\x02" +
        "\xBE\xC2\x07(\x02\x02\xBF\xC1\x05\x18\r\x02\xC0\xBF\x03\x02\x02\x02\xC1" +
        "\xC4\x03\x02\x02\x02\xC2\xC0\x03\x02\x02\x02\xC2\xC3\x03\x02\x02\x02\xC3" +
        "\xC6\x03\x02\x02\x02\xC4\xC2\x03\x02\x02\x02\xC5\xC7\x07\b\x02\x02\xC6" +
        "\xC5\x03\x02\x02\x02\xC6\xC7\x03\x02\x02\x02\xC7\x17\x03\x02\x02\x02\xC8" +
        "\xCF\x05&\x14\x02\xC9\xCF\x05\"\x12\x02\xCA\xCF\x05\x06\x04\x02\xCB\xCF" +
        "\x07$\x02\x02\xCC\xCF\x05\x1A\x0E\x02\xCD\xCF\x05\x1E\x10\x02\xCE\xC8" +
        "\x03\x02\x02\x02\xCE\xC9\x03\x02\x02\x02\xCE\xCA\x03\x02\x02\x02\xCE\xCB" +
        "\x03\x02\x02\x02\xCE\xCC\x03\x02\x02\x02\xCE\xCD\x03\x02\x02\x02\xCF\x19" +
        "\x03\x02\x02\x02\xD0\xD1\x07\t\x02\x02\xD1\xD3\x07&\x02\x02\xD2\xD4\x07" +
        "*\x02\x02\xD3\xD2\x03\x02\x02\x02\xD3\xD4\x03\x02\x02\x02\xD4\xD8\x03" +
        "\x02\x02\x02\xD5\xD7\x07+\x02\x02\xD6\xD5\x03\x02\x02\x02\xD7\xDA\x03" +
        "\x02\x02\x02\xD8\xD6\x03\x02\x02\x02\xD8\xD9\x03\x02\x02\x02\xD9\xDB\x03" +
        "\x02\x02\x02\xDA\xD8\x03\x02\x02\x02\xDB\xDF\x07(\x02\x02\xDC\xDE\x05" +
        "\x1C\x0F\x02\xDD\xDC\x03\x02\x02\x02\xDE\xE1\x03\x02\x02\x02\xDF\xDD\x03" +
        "\x02\x02\x02\xDF\xE0\x03\x02\x02\x02\xE0\xE3\x03\x02\x02\x02\xE1\xDF\x03" +
        "\x02\x02\x02\xE2\xE4\x07\n\x02\x02\xE3\xE2\x03\x02\x02\x02\xE3\xE4\x03" +
        "\x02\x02\x02\xE4\x1B\x03\x02\x02\x02\xE5\xEB\x05&\x14\x02\xE6\xEB\x05" +
        "\"\x12\x02\xE7\xEB\x05\x06\x04\x02\xE8\xEB\x07$\x02\x02\xE9\xEB\x05\x1E" +
        "\x10\x02\xEA\xE5\x03\x02\x02\x02\xEA\xE6\x03\x02\x02\x02\xEA\xE7\x03\x02" +
        "\x02\x02\xEA\xE8\x03\x02\x02\x02\xEA\xE9\x03\x02\x02\x02\xEB\x1D\x03\x02" +
        "\x02\x02\xEC\xED\x07\v\x02\x02\xED\xEF\x07&\x02\x02\xEE\xF0\x07*\x02\x02" +
        "\xEF\xEE\x03\x02\x02\x02\xEF\xF0\x03\x02\x02\x02\xF0\xF4\x03\x02\x02\x02" +
        "\xF1\xF3\x07+\x02\x02\xF2\xF1\x03\x02\x02\x02\xF3\xF6\x03\x02\x02\x02" +
        "\xF4\xF2\x03\x02\x02\x02\xF4\xF5\x03\x02\x02\x02\xF5\xF7\x03\x02\x02\x02" +
        "\xF6\xF4\x03\x02\x02\x02\xF7\xFB\x07(\x02\x02\xF8\xFA\x05 \x11\x02\xF9" +
        "\xF8\x03\x02\x02\x02\xFA\xFD\x03\x02\x02\x02\xFB\xF9\x03\x02\x02\x02\xFB" +
        "\xFC\x03\x02\x02\x02\xFC\xFF\x03\x02\x02\x02\xFD\xFB\x03\x02\x02\x02\xFE" +
        "\u0100\x07\f\x02\x02\xFF\xFE\x03\x02\x02\x02\xFF\u0100\x03\x02\x02\x02" +
        "\u0100\x1F\x03\x02\x02\x02\u0101\u0106\x05&\x14\x02\u0102\u0106\x05\"" +
        "\x12\x02\u0103\u0106\x05\x06\x04\x02\u0104\u0106\x07$\x02\x02\u0105\u0101" +
        "\x03\x02\x02\x02\u0105\u0102\x03\x02\x02\x02\u0105\u0103\x03\x02\x02\x02" +
        "\u0105\u0104\x03\x02\x02\x02\u0106!\x03\x02\x02\x02\u0107\u0109\t\x02" +
        "\x02\x02\u0108\u0107\x03\x02\x02\x02\u0109\u010A\x03\x02\x02\x02\u010A" +
        "\u0108\x03\x02\x02\x02\u010A\u010B\x03\x02\x02\x02\u010B#\x03\x02\x02" +
        "\x02\u010C\u010E\x07\x19\x02\x02\u010D\u010F\x07*\x02\x02\u010E\u010D" +
        "\x03\x02\x02\x02\u010E\u010F\x03\x02\x02\x02\u010F\u0113\x03\x02\x02\x02" +
        "\u0110\u0112\x07+\x02\x02\u0111\u0110\x03\x02\x02\x02\u0112\u0115\x03" +
        "\x02\x02\x02\u0113\u0111\x03\x02\x02\x02\u0113\u0114\x03\x02\x02\x02\u0114" +
        "\u0116\x03\x02\x02\x02\u0115\u0113\x03\x02\x02\x02\u0116\u0117\x07)\x02" +
        "\x02\u0117%\x03\x02\x02\x02\u0118\u0123\x05*\x16\x02\u0119\u0123\x05," +
        "\x17\x02\u011A\u0123\x05.\x18\x02\u011B\u0123\x050\x19\x02\u011C\u0123" +
        "\x052\x1A\x02\u011D\u0123\x054\x1B\x02\u011E\u0123\x056\x1C\x02\u011F" +
        "\u0123\x058\x1D\x02\u0120\u0123\x05:\x1E\x02\u0121\u0123\x05<\x1F\x02" +
        "\u0122\u0118\x03\x02\x02\x02\u0122\u0119\x03\x02\x02\x02\u0122\u011A\x03" +
        "\x02\x02\x02\u0122\u011B\x03\x02\x02\x02\u0122\u011C\x03\x02\x02\x02\u0122" +
        "\u011D\x03\x02\x02\x02\u0122\u011E\x03\x02\x02\x02\u0122\u011F\x03\x02" +
        "\x02\x02\u0122\u0120\x03\x02\x02\x02\u0122\u0121\x03\x02\x02\x02\u0123" +
        "\'\x03\x02\x02\x02\u0124\u012B\x07 \x02\x02\u0125\u012B\x07!\x02\x02\u0126" +
        "\u012B\x07\x1F\x02\x02\u0127\u012B\x052\x1A\x02\u0128\u012B\x054\x1B\x02" +
        "\u0129\u012B\x056\x1C\x02\u012A\u0124\x03\x02\x02\x02\u012A\u0125\x03" +
        "\x02\x02\x02\u012A\u0126\x03\x02\x02\x02\u012A\u0127\x03\x02\x02\x02\u012A" +
        "\u0128\x03\x02\x02\x02\u012A\u0129\x03\x02\x02\x02\u012B)\x03\x02\x02" +
        "\x02\u012C\u012E\x07\x10\x02\x02\u012D\u012C\x03\x02\x02\x02\u012D\u012E" +
        "\x03\x02\x02\x02\u012E\u012F\x03\x02\x02\x02\u012F\u0130\x05(\x15\x02" +
        "\u0130\u0131\x07\x11\x02\x02\u0131\u0134\x07,\x02\x02\u0132\u0133\x07" +
        "-\x02\x02\u0133\u0135\x07,\x02\x02\u0134\u0132\x03\x02\x02\x02\u0134\u0135" +
        "\x03\x02\x02\x02\u0135\u0136\x03\x02\x02\x02\u0136\u0137\x07.\x02\x02" +
        "\u0137+\x03\x02\x02\x02\u0138\u013A\x07\x1A\x02\x02\u0139\u013B\x07/\x02" +
        "\x02\u013A\u0139\x03\x02\x02\x02\u013B\u013C\x03\x02\x02\x02\u013C\u013A" +
        "\x03\x02\x02\x02\u013C\u013D\x03\x02\x02\x02\u013D-\x03\x02\x02\x02\u013E" +
        "\u013F\x07\x1C\x02\x02\u013F\u0140\x07!\x02\x02\u0140/\x03\x02\x02\x02" +
        "\u0141\u0142\x07\x1B\x02\x02\u01421\x03\x02\x02\x02\u0143\u0144\x07\x12" +
        "\x02\x02\u0144\u0145\x070\x02\x02\u0145\u0146\t\x03\x02\x02\u01463\x03" +
        "\x02\x02\x02\u0147\u0149\x07\x1D\x02\x02\u0148\u0147\x03\x02\x02\x02\u0149" +
        "\u014A\x03\x02\x02\x02\u014A\u0148\x03\x02\x02\x02\u014A\u014B\x03\x02" +
        "\x02\x02\u014B5\x03\x02\x02\x02\u014C\u014E\x07\x1E\x02\x02\u014D\u014C" +
        "\x03\x02\x02\x02\u014E\u014F\x03\x02\x02\x02\u014F\u014D\x03\x02\x02\x02" +
        "\u014F\u0150\x03\x02\x02\x02\u01507\x03\x02\x02\x02\u0151\u0153\x07\x13" +
        "\x02\x02\u0152\u0154\x05\n\x06\x02\u0153\u0152\x03\x02\x02\x02\u0154\u0155" +
        "\x03\x02\x02\x02\u0155\u0153\x03\x02\x02\x02\u0155\u0156\x03\x02\x02\x02" +
        "\u0156\u0157\x03\x02\x02\x02\u0157\u0159\x07\x14\x02\x02\u0158\u015A\x05" +
        "$\x13\x02\u0159\u0158\x03\x02\x02\x02\u0159\u015A\x03\x02\x02\x02\u015A" +
        "9\x03\x02\x02\x02\u015B\u015D\x07\x15\x02\x02\u015C\u015E\x05\n\x06\x02" +
        "\u015D\u015C\x03\x02\x02\x02\u015E\u015F\x03\x02\x02\x02\u015F\u015D\x03" +
        "\x02\x02\x02\u015F\u0160\x03\x02\x02\x02\u0160\u0161\x03\x02\x02\x02\u0161" +
        "\u0163\x07\x16\x02\x02\u0162\u0164\x05$\x13\x02\u0163\u0162\x03\x02\x02" +
        "\x02\u0163\u0164\x03\x02\x02\x02\u0164;\x03\x02\x02\x02\u0165\u0167\x07" +
        "\x17\x02\x02\u0166\u0168\x05\n\x06\x02\u0167\u0166\x03\x02\x02\x02\u0168" +
        "\u0169\x03\x02\x02\x02\u0169\u0167\x03\x02\x02\x02\u0169\u016A\x03\x02" +
        "\x02\x02\u016A\u016B\x03\x02\x02\x02\u016B\u016D\x07\x18\x02\x02\u016C" +
        "\u016E\x05$\x13\x02\u016D\u016C\x03\x02\x02\x02\u016D\u016E\x03\x02\x02" +
        "\x02\u016E=\x03\x02\x02\x023AKPU^fmty~\x85\x89\x93\x98\x9D\xA4\xA8\xB1" +
        "\xB6\xBB\xC2\xC6\xCE\xD3\xD8\xDF\xE3\xEA\xEF\xF4\xFB\xFF\u0105\u010A\u010E" +
        "\u0113\u0122\u012A\u012D\u0134\u013C\u014A\u014F\u0155\u0159\u015F\u0163" +
        "\u0169\u016D";
    return KojiParser;
})();
exports.KojiParser = KojiParser;
class KojiContext extends ParserRuleContext_1.ParserRuleContext {
    EOF() { return this.getToken(KojiParser.EOF, 0); }
    list(i) {
        if (i === undefined) {
            return this.getRuleContexts(ListContext);
        }
        else {
            return this.getRuleContext(i, ListContext);
        }
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_koji; }
    // @Override
    enterRule(listener) {
        if (listener.enterKoji) {
            listener.enterKoji(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitKoji) {
            listener.exitKoji(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitKoji) {
            return visitor.visitKoji(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.KojiContext = KojiContext;
class ListContext extends ParserRuleContext_1.ParserRuleContext {
    block() {
        return this.tryGetRuleContext(0, BlockContext);
    }
    inline() {
        return this.tryGetRuleContext(0, InlineContext);
    }
    syntaxSugar() {
        return this.tryGetRuleContext(0, SyntaxSugarContext);
    }
    textSegment() {
        return this.tryGetRuleContext(0, TextSegmentContext);
    }
    Lb() { return this.tryGetToken(KojiParser.Lb, 0); }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_list; }
    // @Override
    enterRule(listener) {
        if (listener.enterList) {
            listener.enterList(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitList) {
            listener.exitList(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitList) {
            return visitor.visitList(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.ListContext = ListContext;
class InlineContext extends ParserRuleContext_1.ParserRuleContext {
    constructor(parent, invokingState) {
        super(parent, invokingState);
        this._content = [];
    }
    OpenInline() { return this.getToken(KojiParser.OpenInline, 0); }
    ElemName() { return this.getToken(KojiParser.ElemName, 0); }
    Colon() { return this.getToken(KojiParser.Colon, 0); }
    CloseInline() { return this.getToken(KojiParser.CloseInline, 0); }
    inlineContentSeq(i) {
        if (i === undefined) {
            return this.getRuleContexts(InlineContentSeqContext);
        }
        else {
            return this.getRuleContext(i, InlineContentSeqContext);
        }
    }
    ID() { return this.tryGetToken(KojiParser.ID, 0); }
    Class(i) {
        if (i === undefined) {
            return this.getTokens(KojiParser.Class);
        }
        else {
            return this.getToken(KojiParser.Class, i);
        }
    }
    Bar(i) {
        if (i === undefined) {
            return this.getTokens(KojiParser.Bar);
        }
        else {
            return this.getToken(KojiParser.Bar, i);
        }
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_inline; }
    // @Override
    enterRule(listener) {
        if (listener.enterInline) {
            listener.enterInline(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitInline) {
            listener.exitInline(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitInline) {
            return visitor.visitInline(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.InlineContext = InlineContext;
class InlineContentSeqContext extends ParserRuleContext_1.ParserRuleContext {
    inlineContent(i) {
        if (i === undefined) {
            return this.getRuleContexts(InlineContentContext);
        }
        else {
            return this.getRuleContext(i, InlineContentContext);
        }
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_inlineContentSeq; }
    // @Override
    enterRule(listener) {
        if (listener.enterInlineContentSeq) {
            listener.enterInlineContentSeq(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitInlineContentSeq) {
            listener.exitInlineContentSeq(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitInlineContentSeq) {
            return visitor.visitInlineContentSeq(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.InlineContentSeqContext = InlineContentSeqContext;
class InlineContentContext extends ParserRuleContext_1.ParserRuleContext {
    syntaxSugar() {
        return this.tryGetRuleContext(0, SyntaxSugarContext);
    }
    textSegment() {
        return this.tryGetRuleContext(0, TextSegmentContext);
    }
    inline() {
        return this.tryGetRuleContext(0, InlineContext);
    }
    Lb() { return this.tryGetToken(KojiParser.Lb, 0); }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_inlineContent; }
    // @Override
    enterRule(listener) {
        if (listener.enterInlineContent) {
            listener.enterInlineContent(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitInlineContent) {
            listener.exitInlineContent(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitInlineContent) {
            return visitor.visitInlineContent(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.InlineContentContext = InlineContentContext;
class BlockContext extends ParserRuleContext_1.ParserRuleContext {
    block1() {
        return this.tryGetRuleContext(0, Block1Context);
    }
    block2() {
        return this.tryGetRuleContext(0, Block2Context);
    }
    block3() {
        return this.tryGetRuleContext(0, Block3Context);
    }
    block4() {
        return this.tryGetRuleContext(0, Block4Context);
    }
    block5() {
        return this.tryGetRuleContext(0, Block5Context);
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_block; }
    // @Override
    enterRule(listener) {
        if (listener.enterBlock) {
            listener.enterBlock(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitBlock) {
            listener.exitBlock(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitBlock) {
            return visitor.visitBlock(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.BlockContext = BlockContext;
class Block1Context extends ParserRuleContext_1.ParserRuleContext {
    constructor(parent, invokingState) {
        super(parent, invokingState);
        this._content = [];
    }
    OpenBlock1() { return this.getToken(KojiParser.OpenBlock1, 0); }
    ElemName() { return this.getToken(KojiParser.ElemName, 0); }
    HeaderLb() { return this.getToken(KojiParser.HeaderLb, 0); }
    ID() { return this.tryGetToken(KojiParser.ID, 0); }
    Class(i) {
        if (i === undefined) {
            return this.getTokens(KojiParser.Class);
        }
        else {
            return this.getToken(KojiParser.Class, i);
        }
    }
    CloseBlock1() { return this.tryGetToken(KojiParser.CloseBlock1, 0); }
    blockContent1(i) {
        if (i === undefined) {
            return this.getRuleContexts(BlockContent1Context);
        }
        else {
            return this.getRuleContext(i, BlockContent1Context);
        }
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_block1; }
    // @Override
    enterRule(listener) {
        if (listener.enterBlock1) {
            listener.enterBlock1(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitBlock1) {
            listener.exitBlock1(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitBlock1) {
            return visitor.visitBlock1(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.Block1Context = Block1Context;
class BlockContent1Context extends ParserRuleContext_1.ParserRuleContext {
    syntaxSugar() {
        return this.tryGetRuleContext(0, SyntaxSugarContext);
    }
    textSegment() {
        return this.tryGetRuleContext(0, TextSegmentContext);
    }
    inline() {
        return this.tryGetRuleContext(0, InlineContext);
    }
    Lb() { return this.tryGetToken(KojiParser.Lb, 0); }
    block2() {
        return this.tryGetRuleContext(0, Block2Context);
    }
    block3() {
        return this.tryGetRuleContext(0, Block3Context);
    }
    block4() {
        return this.tryGetRuleContext(0, Block4Context);
    }
    block5() {
        return this.tryGetRuleContext(0, Block5Context);
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_blockContent1; }
    // @Override
    enterRule(listener) {
        if (listener.enterBlockContent1) {
            listener.enterBlockContent1(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitBlockContent1) {
            listener.exitBlockContent1(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitBlockContent1) {
            return visitor.visitBlockContent1(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.BlockContent1Context = BlockContent1Context;
class Block2Context extends ParserRuleContext_1.ParserRuleContext {
    constructor(parent, invokingState) {
        super(parent, invokingState);
        this._content = [];
    }
    OpenBlock2() { return this.getToken(KojiParser.OpenBlock2, 0); }
    ElemName() { return this.getToken(KojiParser.ElemName, 0); }
    HeaderLb() { return this.getToken(KojiParser.HeaderLb, 0); }
    ID() { return this.tryGetToken(KojiParser.ID, 0); }
    Class(i) {
        if (i === undefined) {
            return this.getTokens(KojiParser.Class);
        }
        else {
            return this.getToken(KojiParser.Class, i);
        }
    }
    CloseBlock2() { return this.tryGetToken(KojiParser.CloseBlock2, 0); }
    blockContent2(i) {
        if (i === undefined) {
            return this.getRuleContexts(BlockContent2Context);
        }
        else {
            return this.getRuleContext(i, BlockContent2Context);
        }
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_block2; }
    // @Override
    enterRule(listener) {
        if (listener.enterBlock2) {
            listener.enterBlock2(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitBlock2) {
            listener.exitBlock2(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitBlock2) {
            return visitor.visitBlock2(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.Block2Context = Block2Context;
class BlockContent2Context extends ParserRuleContext_1.ParserRuleContext {
    syntaxSugar() {
        return this.tryGetRuleContext(0, SyntaxSugarContext);
    }
    textSegment() {
        return this.tryGetRuleContext(0, TextSegmentContext);
    }
    inline() {
        return this.tryGetRuleContext(0, InlineContext);
    }
    Lb() { return this.tryGetToken(KojiParser.Lb, 0); }
    block3() {
        return this.tryGetRuleContext(0, Block3Context);
    }
    block4() {
        return this.tryGetRuleContext(0, Block4Context);
    }
    block5() {
        return this.tryGetRuleContext(0, Block5Context);
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_blockContent2; }
    // @Override
    enterRule(listener) {
        if (listener.enterBlockContent2) {
            listener.enterBlockContent2(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitBlockContent2) {
            listener.exitBlockContent2(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitBlockContent2) {
            return visitor.visitBlockContent2(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.BlockContent2Context = BlockContent2Context;
class Block3Context extends ParserRuleContext_1.ParserRuleContext {
    constructor(parent, invokingState) {
        super(parent, invokingState);
        this._content = [];
    }
    OpenBlock3() { return this.getToken(KojiParser.OpenBlock3, 0); }
    ElemName() { return this.getToken(KojiParser.ElemName, 0); }
    HeaderLb() { return this.getToken(KojiParser.HeaderLb, 0); }
    ID() { return this.tryGetToken(KojiParser.ID, 0); }
    Class(i) {
        if (i === undefined) {
            return this.getTokens(KojiParser.Class);
        }
        else {
            return this.getToken(KojiParser.Class, i);
        }
    }
    CloseBlock3() { return this.tryGetToken(KojiParser.CloseBlock3, 0); }
    blockContent3(i) {
        if (i === undefined) {
            return this.getRuleContexts(BlockContent3Context);
        }
        else {
            return this.getRuleContext(i, BlockContent3Context);
        }
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_block3; }
    // @Override
    enterRule(listener) {
        if (listener.enterBlock3) {
            listener.enterBlock3(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitBlock3) {
            listener.exitBlock3(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitBlock3) {
            return visitor.visitBlock3(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.Block3Context = Block3Context;
class BlockContent3Context extends ParserRuleContext_1.ParserRuleContext {
    syntaxSugar() {
        return this.tryGetRuleContext(0, SyntaxSugarContext);
    }
    textSegment() {
        return this.tryGetRuleContext(0, TextSegmentContext);
    }
    inline() {
        return this.tryGetRuleContext(0, InlineContext);
    }
    Lb() { return this.tryGetToken(KojiParser.Lb, 0); }
    block4() {
        return this.tryGetRuleContext(0, Block4Context);
    }
    block5() {
        return this.tryGetRuleContext(0, Block5Context);
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_blockContent3; }
    // @Override
    enterRule(listener) {
        if (listener.enterBlockContent3) {
            listener.enterBlockContent3(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitBlockContent3) {
            listener.exitBlockContent3(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitBlockContent3) {
            return visitor.visitBlockContent3(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.BlockContent3Context = BlockContent3Context;
class Block4Context extends ParserRuleContext_1.ParserRuleContext {
    constructor(parent, invokingState) {
        super(parent, invokingState);
        this._content = [];
    }
    OpenBlock4() { return this.getToken(KojiParser.OpenBlock4, 0); }
    ElemName() { return this.getToken(KojiParser.ElemName, 0); }
    HeaderLb() { return this.getToken(KojiParser.HeaderLb, 0); }
    ID() { return this.tryGetToken(KojiParser.ID, 0); }
    Class(i) {
        if (i === undefined) {
            return this.getTokens(KojiParser.Class);
        }
        else {
            return this.getToken(KojiParser.Class, i);
        }
    }
    CloseBlock4() { return this.tryGetToken(KojiParser.CloseBlock4, 0); }
    blockContent4(i) {
        if (i === undefined) {
            return this.getRuleContexts(BlockContent4Context);
        }
        else {
            return this.getRuleContext(i, BlockContent4Context);
        }
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_block4; }
    // @Override
    enterRule(listener) {
        if (listener.enterBlock4) {
            listener.enterBlock4(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitBlock4) {
            listener.exitBlock4(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitBlock4) {
            return visitor.visitBlock4(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.Block4Context = Block4Context;
class BlockContent4Context extends ParserRuleContext_1.ParserRuleContext {
    syntaxSugar() {
        return this.tryGetRuleContext(0, SyntaxSugarContext);
    }
    textSegment() {
        return this.tryGetRuleContext(0, TextSegmentContext);
    }
    inline() {
        return this.tryGetRuleContext(0, InlineContext);
    }
    Lb() { return this.tryGetToken(KojiParser.Lb, 0); }
    block5() {
        return this.tryGetRuleContext(0, Block5Context);
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_blockContent4; }
    // @Override
    enterRule(listener) {
        if (listener.enterBlockContent4) {
            listener.enterBlockContent4(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitBlockContent4) {
            listener.exitBlockContent4(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitBlockContent4) {
            return visitor.visitBlockContent4(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.BlockContent4Context = BlockContent4Context;
class Block5Context extends ParserRuleContext_1.ParserRuleContext {
    constructor(parent, invokingState) {
        super(parent, invokingState);
        this._content = [];
    }
    OpenBlock5() { return this.getToken(KojiParser.OpenBlock5, 0); }
    ElemName() { return this.getToken(KojiParser.ElemName, 0); }
    HeaderLb() { return this.getToken(KojiParser.HeaderLb, 0); }
    ID() { return this.tryGetToken(KojiParser.ID, 0); }
    Class(i) {
        if (i === undefined) {
            return this.getTokens(KojiParser.Class);
        }
        else {
            return this.getToken(KojiParser.Class, i);
        }
    }
    CloseBlock5() { return this.tryGetToken(KojiParser.CloseBlock5, 0); }
    blockContent5(i) {
        if (i === undefined) {
            return this.getRuleContexts(BlockContent5Context);
        }
        else {
            return this.getRuleContext(i, BlockContent5Context);
        }
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_block5; }
    // @Override
    enterRule(listener) {
        if (listener.enterBlock5) {
            listener.enterBlock5(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitBlock5) {
            listener.exitBlock5(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitBlock5) {
            return visitor.visitBlock5(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.Block5Context = Block5Context;
class BlockContent5Context extends ParserRuleContext_1.ParserRuleContext {
    syntaxSugar() {
        return this.tryGetRuleContext(0, SyntaxSugarContext);
    }
    textSegment() {
        return this.tryGetRuleContext(0, TextSegmentContext);
    }
    inline() {
        return this.tryGetRuleContext(0, InlineContext);
    }
    Lb() { return this.tryGetToken(KojiParser.Lb, 0); }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_blockContent5; }
    // @Override
    enterRule(listener) {
        if (listener.enterBlockContent5) {
            listener.enterBlockContent5(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitBlockContent5) {
            listener.exitBlockContent5(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitBlockContent5) {
            return visitor.visitBlockContent5(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.BlockContent5Context = BlockContent5Context;
class TextSegmentContext extends ParserRuleContext_1.ParserRuleContext {
    Kanji(i) {
        if (i === undefined) {
            return this.getTokens(KojiParser.Kanji);
        }
        else {
            return this.getToken(KojiParser.Kanji, i);
        }
    }
    Kana(i) {
        if (i === undefined) {
            return this.getTokens(KojiParser.Kana);
        }
        else {
            return this.getToken(KojiParser.Kana, i);
        }
    }
    NonJp(i) {
        if (i === undefined) {
            return this.getTokens(KojiParser.NonJp);
        }
        else {
            return this.getToken(KojiParser.NonJp, i);
        }
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_textSegment; }
    // @Override
    enterRule(listener) {
        if (listener.enterTextSegment) {
            listener.enterTextSegment(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitTextSegment) {
            listener.exitTextSegment(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitTextSegment) {
            return visitor.visitTextSegment(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.TextSegmentContext = TextSegmentContext;
class PostPositionedAttrsContext extends ParserRuleContext_1.ParserRuleContext {
    AttrsOpen() { return this.getToken(KojiParser.AttrsOpen, 0); }
    AttrsClose() { return this.getToken(KojiParser.AttrsClose, 0); }
    ID() { return this.tryGetToken(KojiParser.ID, 0); }
    Class(i) {
        if (i === undefined) {
            return this.getTokens(KojiParser.Class);
        }
        else {
            return this.getToken(KojiParser.Class, i);
        }
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_postPositionedAttrs; }
    // @Override
    enterRule(listener) {
        if (listener.enterPostPositionedAttrs) {
            listener.enterPostPositionedAttrs(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitPostPositionedAttrs) {
            listener.exitPostPositionedAttrs(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPostPositionedAttrs) {
            return visitor.visitPostPositionedAttrs(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.PostPositionedAttrsContext = PostPositionedAttrsContext;
class SyntaxSugarContext extends ParserRuleContext_1.ParserRuleContext {
    furigana() {
        return this.tryGetRuleContext(0, FuriganaContext);
    }
    kaeriten() {
        return this.tryGetRuleContext(0, KaeritenContext);
    }
    okurigana() {
        return this.tryGetRuleContext(0, OkuriganaContext);
    }
    tateten() {
        return this.tryGetRuleContext(0, TatetenContext);
    }
    annotation() {
        return this.tryGetRuleContext(0, AnnotationContext);
    }
    illegible() {
        return this.tryGetRuleContext(0, IllegibleContext);
    }
    bugHole() {
        return this.tryGetRuleContext(0, BugHoleContext);
    }
    person() {
        return this.tryGetRuleContext(0, PersonContext);
    }
    place() {
        return this.tryGetRuleContext(0, PlaceContext);
    }
    date() {
        return this.tryGetRuleContext(0, DateContext);
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_syntaxSugar; }
    // @Override
    enterRule(listener) {
        if (listener.enterSyntaxSugar) {
            listener.enterSyntaxSugar(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitSyntaxSugar) {
            listener.exitSyntaxSugar(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSyntaxSugar) {
            return visitor.visitSyntaxSugar(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.SyntaxSugarContext = SyntaxSugarContext;
class FuriganaTargetContext extends ParserRuleContext_1.ParserRuleContext {
    Kanji() { return this.tryGetToken(KojiParser.Kanji, 0); }
    Kana() { return this.tryGetToken(KojiParser.Kana, 0); }
    NonJp() { return this.tryGetToken(KojiParser.NonJp, 0); }
    annotation() {
        return this.tryGetRuleContext(0, AnnotationContext);
    }
    illegible() {
        return this.tryGetRuleContext(0, IllegibleContext);
    }
    bugHole() {
        return this.tryGetRuleContext(0, BugHoleContext);
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_furiganaTarget; }
    // @Override
    enterRule(listener) {
        if (listener.enterFuriganaTarget) {
            listener.enterFuriganaTarget(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitFuriganaTarget) {
            listener.exitFuriganaTarget(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitFuriganaTarget) {
            return visitor.visitFuriganaTarget(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.FuriganaTargetContext = FuriganaTargetContext;
class FuriganaContext extends ParserRuleContext_1.ParserRuleContext {
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    FuriganaOpen() { return this.getToken(KojiParser.FuriganaOpen, 0); }
    FuriganaClose() { return this.getToken(KojiParser.FuriganaClose, 0); }
    FuriganaContent(i) {
        if (i === undefined) {
            return this.getTokens(KojiParser.FuriganaContent);
        }
        else {
            return this.getToken(KojiParser.FuriganaContent, i);
        }
    }
    FuriganaPre() { return this.tryGetToken(KojiParser.FuriganaPre, 0); }
    furiganaTarget() {
        return this.tryGetRuleContext(0, FuriganaTargetContext);
    }
    FuriganaSep() { return this.tryGetToken(KojiParser.FuriganaSep, 0); }
    // @Override
    get ruleIndex() { return KojiParser.RULE_furigana; }
    // @Override
    enterRule(listener) {
        if (listener.enterFurigana) {
            listener.enterFurigana(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitFurigana) {
            listener.exitFurigana(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitFurigana) {
            return visitor.visitFurigana(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.FuriganaContext = FuriganaContext;
class KaeritenContext extends ParserRuleContext_1.ParserRuleContext {
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    KaeritenMark() { return this.getToken(KojiParser.KaeritenMark, 0); }
    KaeritenChar(i) {
        if (i === undefined) {
            return this.getTokens(KojiParser.KaeritenChar);
        }
        else {
            return this.getToken(KojiParser.KaeritenChar, i);
        }
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_kaeriten; }
    // @Override
    enterRule(listener) {
        if (listener.enterKaeriten) {
            listener.enterKaeriten(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitKaeriten) {
            listener.exitKaeriten(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitKaeriten) {
            return visitor.visitKaeriten(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.KaeritenContext = KaeritenContext;
class OkuriganaContext extends ParserRuleContext_1.ParserRuleContext {
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    OkuriganaMark() { return this.getToken(KojiParser.OkuriganaMark, 0); }
    Kana() { return this.getToken(KojiParser.Kana, 0); }
    // @Override
    get ruleIndex() { return KojiParser.RULE_okurigana; }
    // @Override
    enterRule(listener) {
        if (listener.enterOkurigana) {
            listener.enterOkurigana(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitOkurigana) {
            listener.exitOkurigana(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitOkurigana) {
            return visitor.visitOkurigana(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.OkuriganaContext = OkuriganaContext;
class TatetenContext extends ParserRuleContext_1.ParserRuleContext {
    TatetenChar() { return this.getToken(KojiParser.TatetenChar, 0); }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_tateten; }
    // @Override
    enterRule(listener) {
        if (listener.enterTateten) {
            listener.enterTateten(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitTateten) {
            listener.exitTateten(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitTateten) {
            return visitor.visitTateten(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.TatetenContext = TatetenContext;
class AnnotationContext extends ParserRuleContext_1.ParserRuleContext {
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    AnnotationOpen() { return this.getToken(KojiParser.AnnotationOpen, 0); }
    AnnotationContent() { return this.getToken(KojiParser.AnnotationContent, 0); }
    AnnotationClose() { return this.tryGetToken(KojiParser.AnnotationClose, 0); }
    EOF() { return this.tryGetToken(KojiParser.EOF, 0); }
    // @Override
    get ruleIndex() { return KojiParser.RULE_annotation; }
    // @Override
    enterRule(listener) {
        if (listener.enterAnnotation) {
            listener.enterAnnotation(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitAnnotation) {
            listener.exitAnnotation(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAnnotation) {
            return visitor.visitAnnotation(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.AnnotationContext = AnnotationContext;
class IllegibleContext extends ParserRuleContext_1.ParserRuleContext {
    IllegibleMark(i) {
        if (i === undefined) {
            return this.getTokens(KojiParser.IllegibleMark);
        }
        else {
            return this.getToken(KojiParser.IllegibleMark, i);
        }
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_illegible; }
    // @Override
    enterRule(listener) {
        if (listener.enterIllegible) {
            listener.enterIllegible(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitIllegible) {
            listener.exitIllegible(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitIllegible) {
            return visitor.visitIllegible(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.IllegibleContext = IllegibleContext;
class BugHoleContext extends ParserRuleContext_1.ParserRuleContext {
    BugHoleMark(i) {
        if (i === undefined) {
            return this.getTokens(KojiParser.BugHoleMark);
        }
        else {
            return this.getToken(KojiParser.BugHoleMark, i);
        }
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_bugHole; }
    // @Override
    enterRule(listener) {
        if (listener.enterBugHole) {
            listener.enterBugHole(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitBugHole) {
            listener.exitBugHole(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitBugHole) {
            return visitor.visitBugHole(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.BugHoleContext = BugHoleContext;
class PersonContext extends ParserRuleContext_1.ParserRuleContext {
    constructor(parent, invokingState) {
        super(parent, invokingState);
        this._content = [];
    }
    PersonOpen() { return this.getToken(KojiParser.PersonOpen, 0); }
    PersonClose() { return this.getToken(KojiParser.PersonClose, 0); }
    postPositionedAttrs() {
        return this.tryGetRuleContext(0, PostPositionedAttrsContext);
    }
    inlineContent(i) {
        if (i === undefined) {
            return this.getRuleContexts(InlineContentContext);
        }
        else {
            return this.getRuleContext(i, InlineContentContext);
        }
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_person; }
    // @Override
    enterRule(listener) {
        if (listener.enterPerson) {
            listener.enterPerson(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitPerson) {
            listener.exitPerson(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPerson) {
            return visitor.visitPerson(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.PersonContext = PersonContext;
class PlaceContext extends ParserRuleContext_1.ParserRuleContext {
    constructor(parent, invokingState) {
        super(parent, invokingState);
        this._content = [];
    }
    PlaceOpen() { return this.getToken(KojiParser.PlaceOpen, 0); }
    PlaceClose() { return this.getToken(KojiParser.PlaceClose, 0); }
    postPositionedAttrs() {
        return this.tryGetRuleContext(0, PostPositionedAttrsContext);
    }
    inlineContent(i) {
        if (i === undefined) {
            return this.getRuleContexts(InlineContentContext);
        }
        else {
            return this.getRuleContext(i, InlineContentContext);
        }
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_place; }
    // @Override
    enterRule(listener) {
        if (listener.enterPlace) {
            listener.enterPlace(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitPlace) {
            listener.exitPlace(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPlace) {
            return visitor.visitPlace(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.PlaceContext = PlaceContext;
class DateContext extends ParserRuleContext_1.ParserRuleContext {
    constructor(parent, invokingState) {
        super(parent, invokingState);
        this._content = [];
    }
    DateOpen() { return this.getToken(KojiParser.DateOpen, 0); }
    DateClose() { return this.getToken(KojiParser.DateClose, 0); }
    postPositionedAttrs() {
        return this.tryGetRuleContext(0, PostPositionedAttrsContext);
    }
    inlineContent(i) {
        if (i === undefined) {
            return this.getRuleContexts(InlineContentContext);
        }
        else {
            return this.getRuleContext(i, InlineContentContext);
        }
    }
    // @Override
    get ruleIndex() { return KojiParser.RULE_date; }
    // @Override
    enterRule(listener) {
        if (listener.enterDate) {
            listener.enterDate(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitDate) {
            listener.exitDate(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDate) {
            return visitor.visitDate(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.DateContext = DateContext;
//# sourceMappingURL=data:application/json;base64,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